import axios from "axios";
import configuration from "@/utils/configuration";
import { handleError } from "@/utils/errorHandler";
import { executeAction } from "@/services/api/helpers";
import { categoryService } from "@/services/api/features/categoryService";


const categoryModules = {
  namespaced: true,

  state: {
    categories: [],
    loading: {},
    error: {},
  },
  getters: {
    allCategories: (state) => state.categories,
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_LOADING(state, { action, status }) {
      state.loading = { ...state.loading, [action]: status };
    },
    SET_ERROR(state, { action, message }) {
      state.error = { ...state.error, [action]: message };
    },
  },
  actions: {
    //-------------- Manage Categories Modules -----------------

    async fetchCategories({ commit }) {
      return executeAction(
        { commit, key: "fetchCategories" },
        () => categoryService.fetchCategories(),
        { success: (data) => commit("SET_CATEGORIES", data.data.items) }
      );
    },
    async fetchCategoryList({ commit }) {
      return executeAction(
        { commit, key: "fetchCategoryList" },
        () => categoryService.fetchCategoryList (),
        { success: (data) => commit("SET_CATEGORIES", data.data) }
      );
    },
    async fetchCategoryById({ commit }, categoryId) {
      return executeAction({ commit, key: "fetchCategoryById" }, () =>
        categoryService.fetchCategoryById(categoryId)
      );
    },
    async fetchRecommendCourse({ commit }) {
      return executeAction({ commit, key: "fetchRecommendCourse" }, () =>
        categoryService.fetchRecommendCourse()
      );
    },
    async fetchHotCategory({ commit }) {
      return executeAction({ commit, key: "fetchHotCategory" }, () =>
        categoryService.fetchHotCategory()
      );
    },
    async getAllCategories({ commit},params ) {
      return executeAction(
        { commit, key: "getAllCategories" },
        () => categoryService.getAllCategories(params),
        { success: (data) => commit("SET_CATEGORIES", data.data) }
      );
    },
    async deleteCategoryImg({ commit }, categoryId) {
      return executeAction({ commit, key: "deleteCategoryImg" }, () =>
        categoryService.deleteCategoryImg(categoryId)
      );
    },
    async patchCategoryImg({ commit }, categoryId,payload) {
      return executeAction({ commit, key: "patchCategoryImg" }, () =>
        categoryService.patchCategoryImg(categoryId,payload)
      );
    },
    // ------------- FOR ADMIN -------------------

    async getManageCategoryById({ commit }, categoryId) {
      const action = "getManageCategoryById";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/category/management/search`,
          withCredentials: true,
          params: { category_id: categoryId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async getSearchCategry({ commit }, keyword) {
      const action = "getSearchCategry";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/category/getByKeyword`,
          withCredentials: true,
          params: keyword,
        });
        commit("SET_CATEGORIES", data.data);
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postCategory({ commit }, payload) {
      const action = "postCategory";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/category`,
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
          data: payload,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async patchCategory({ commit }, { categoryId, payload }) {
      const action = "patchCategory";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/category`,
          withCredentials: true,
          params: { category_id: categoryId },
          data: payload,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async patchCategoryStatus({ commit }, { categoryId, status }) {
      const action = "patchCourseStatus";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/category/update-status`,
          withCredentials: true,
          params: {
            category_id: categoryId,
            is_active: status,
          },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async deleteCategory({ commit }, categoryId) {
      const action = "deleteCategory";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "DELETE",
          url: `${configuration.backUrl}/category`,
          withCredentials: true,
          params: { category_id: categoryId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
  },
};

export default categoryModules;

